import { DefaultState } from 'store/reducers/types';

export const READ_TALENT_TABLE_DATA_REQUEST = "READ_TALENT_TABLE_DATA_REQUEST";
export const READ_TALENT_TABLE_DATA_SUCCESS = "READ_TALENT_TABLE_DATA_SUCCESS";
export const READ_TALENT_TABLE_DATA_FAILURE = "READ_TALENT_TABLE_DATA_FAILURE";

export interface TalentData {
  initiatedNotContacted: number;
  initiatedNotComplete: number;
  acceptedNotLoggedInWithJobs: number,
  assignedNotLoggedIn: number;
  workedLastDaysCount: number;
};

export type TalentState = DefaultState & {
  contents?: TalentData;
};

interface ReadTalentDataRequest {
  type: typeof READ_TALENT_TABLE_DATA_REQUEST;
};

interface ReadTalentDataSuccess {
  type: typeof READ_TALENT_TABLE_DATA_SUCCESS;
  contents: TalentData;
}

interface ReadTalentDataFailure {
  type: typeof READ_TALENT_TABLE_DATA_FAILURE;
}

export type TalentActionTypes = ReadTalentDataRequest | ReadTalentDataSuccess | ReadTalentDataFailure;